export enum EUserType {
  student = "student",
  teacher = "teacher",
  admin = "admin"
}
